<div class="switcher-container">
  <span class="switcher switcher-2">
    <div class="icon-container" *ngIf="currentSlideState === 0">
      <div
        *ngIf="!isLoading"
        class="icon right"
        (mousedown)="startDrag($event)"
        (mousemove)="onDrag($event)"
        (mouseup)="endDrag($event)"
        (mouseleave)="endDrag($event)"
        (touchstart)="startDrag($event)"
        (touchmove)="onDrag($event)"
        (touchend)="endDrag($event)"
      >
        <div class="right"></div>
        <div class="right"></div>
      </div>
      <app-spinner class="left" *ngIf="isLoading" color="white"></app-spinner>
      <div class="arrow-animation" *ngIf="!isDragging && !isDragSuccess">
        <span class="arrow-white left"></span>
        <span class="arrow-white left"></span>
        <span class="arrow-white left"></span>
      </div>
    </div>

    <input
      disabled
      [checked]="currentSlideState === 1"
      type="checkbox"
      id="switcher-2"
    />
    <label
      for="switcher-2"
      [ngStyle]="{
        'padding-left': currentSlideState === 0 ? '60px' : '0px',
        'padding-right': currentSlideState === 1 ? '48px' : '0px'
      }"
    >
      {{ currentSlideState === 0 ? primaryText : secondaryText }}
    </label>

    <div *ngIf="currentSlideState === 1" class="icon-container right">
      <div
        class="icon left"
        *ngIf="!isLoading"
        (mousedown)="startDrag($event)"
        (mousemove)="onDrag($event)"
        (mouseup)="endDrag($event)"
        (mouseleave)="endDrag($event)"
        (touchstart)="startDrag($event)"
        (touchmove)="onDrag($event)"
        (touchend)="endDrag($event)"
      >
        <div class="left"></div>
        <div class="left"></div>
      </div>
      <app-spinner class="right" *ngIf="isLoading" color="white"></app-spinner>
      <div class="arrow-animation" *ngIf="!isDragging && !isDragSuccess">
        <span class="arrow-white right"></span>
        <span class="arrow-white right"></span>
        <span class="arrow-white right"></span>
      </div>
    </div>
  </span>
</div>
